import { useEffect, useRef, useState } from "react";
import { Dropdown } from "@oc-labs/wt-storybook";

export default function AssetDropup({ options, onChange, placeholder, disabled }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const ref = useRef(null);

  useEffect(() => {
    if (!open) setSearch("");
  }, [open]);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const filtered = options.filter(
    (o) => o.value !== "" && o.label.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div ref={ref} className="relative">
      <div className="pointer-events-none">
        <Dropdown value="" onChange={() => {}} options={[]} placeholder={placeholder} disabled={disabled} />
      </div>
      {!disabled && (
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
          aria-label="Open asset selector"
        />
      )}

      {open && (
        <div className="absolute bottom-full mb-1 left-0 w-full z-50 bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden">
          <div className="p-2 border-b border-gray-100">
            <input
              autoFocus
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search asset..."
              className="w-full rounded-lg border border-gray-300 px-3 py-1.5 text-sm outline-none focus:border-blue-400"
            />
          </div>
          <ul className="max-h-44 overflow-y-auto">
            {filtered.length === 0 && (
              <li className="px-3 py-2 text-sm text-gray-400">No results</li>
            )}
            {filtered.map((o) => (
              <li
                key={o.value}
                onMouseDown={() => {
                  onChange(o.value);
                  setOpen(false);
                }}
                className="px-3 py-2 text-sm cursor-pointer hover:bg-blue-50 hover:text-blue-700"
              >
                {o.label}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
